import { RouteConfig } from 'vue-router'

export const summer2026HomeworkIndexRoute: RouteConfig = {
  path: '/activity/summer-vacation-2026-homework',
  name: 'summer_vacation_2026_homework',
  component: () => import('./2026-summer/index.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '暑假作业活动',
    ignoreLogin: true,
  },
}

export const fall2026HomeworkIndexRoute: RouteConfig = {
  path: '/activity/fall-semester-2026-homework',
  name: 'fall_semester_2026_homework',
  component: () => import('./2026-fall/Index.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '2026新学期作业活动',
    ignoreLogin: true,
  },
}

export const semesterPlanHomeworkInviteRecordsRoute: RouteConfig = {
  path: '/activity/semester-plan-homework/invite-records',
  name: 'semester_plan_homework_invite_records',
  component: () => import('./invite-records/InviteRecords.vue'),
  props: (route) => ({
    activityId: (route.query.activityId as string) || 'summer_2026',
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '邀请记录',
    ignoreLogin: true,
  },
}

export const semesterPlanHomeworkLotteryRecordsRoute: RouteConfig = {
  path: '/activity/semester-plan-homework/lottery-records',
  name: 'semester_plan_homework_lottery_records',
  component: () => import('./lottery-records/LotteryRecords.vue'),
  props: (route) => ({
    activityId: (route.query.activityId as string) || 'summer_2026',
    ...route.query,
    ...route.params,
  }),
  meta: {
    title: '抽奖记录',
    ignoreLogin: true,
  },
}

export default [
  summer2026HomeworkIndexRoute,
  fall2026HomeworkIndexRoute,
  semesterPlanHomeworkInviteRecordsRoute,
  semesterPlanHomeworkLotteryRecordsRoute,
]
